/**
 * Calculate the duration between two month indices
 * 
 * @param {number} startMonthIndex - The index of the start month (0-based)
 * @param {number} endMonthIndex - The index of the end month (0-based)
 * @returns {number} The duration in months (minimum 1)
 */
export const calculateDuration = (startMonthIndex, endMonthIndex) => {
  if (startMonthIndex === null || endMonthIndex === null) {
    return 1;
  }
  
  // Calculate duration (add 1 because it's inclusive)
  const duration = endMonthIndex - startMonthIndex + 1;
  
  // Ensure minimum duration of 1 month
  return Math.max(1, duration);
};

/**
 * Calculate the end month index based on a start month and duration
 * 
 * @param {number} startMonthIndex - The index of the start month (0-based)
 * @param {number} duration - The duration in months
 * @returns {number} The index of the end month
 */
export const calculateEndMonth = (startMonthIndex, duration) => {
  if (startMonthIndex === null || duration === null) {
    return startMonthIndex || 0;
  }
  
  // Calculate end month (subtract 1 because it's inclusive)
  return startMonthIndex + duration - 1;
};

/**
 * Status options with their corresponding color classes
 */
export const statusOptions = [
  { id: 1, name: 'Complete', color: 'bg-green-100 dark:bg-green-900/60 text-green-800 dark:text-green-300' },
  { id: 2, name: 'On Going', color: 'bg-yellow-100 dark:bg-yellow-900/60 text-yellow-800 dark:text-yellow-300' },
  { id: 3, name: 'Not Started On site', color: 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300' },
  { id: 4, name: 'Bidding', color: 'bg-blue-100 dark:bg-blue-900/60 text-blue-800 dark:text-blue-300' },
  { id: 5, name: 'Fabrication', color: 'bg-purple-100 dark:bg-purple-900/60 text-purple-800 dark:text-purple-300' }
];

/**
 * Get color classes for a given status name
 * 
 * @param {string} statusName - The name of the status
 * @returns {string} Tailwind CSS classes for the status
 */
export const getStatusColor = (statusName) => {
  // Direct match first
  const statusOption = statusOptions.find(option => 
    option.name === statusName
  );
  
  if (statusOption) {
    return statusOption.color;
  }
  
  // Fall back to partial match for backward compatibility
  for (const option of statusOptions) {
    if (statusName && option.name && 
        statusName.toLowerCase().includes(option.name.toLowerCase())) {
      return option.color;
    }
  }
  
  return 'bg-gray-100 text-gray-800'; // Default fallback
};